module.exports = __webpack_public_path__ + "assets/IDCardB.2086011f.svg";